import { FC } from 'react';
import { generatePath, Navigate, useParams } from 'react-router-dom';

// Redirects a retired route to its replacement `to` pattern with the current route's params filled in.
export const LegacyRedirect: FC<{ to: string }> = ({ to }) => {
  const params = useParams();

  return <Navigate to={generatePath(to, params)} replace />;
};

export default LegacyRedirect;
